module.exports = __webpack_public_path__ + "img/8.59543ce2.png";